<template>
  <ApplicantForm :formLabel="'تعديل البيانات'" :formFields="formFields" :documents="documents"
    :nationalityId="formFields.nationalityId.value"  v-model:isDisabled="isFormDisabled" :appStatus="STATUS" />
  <alert-modal ref="alertModal" :redirectUrl="redirectTo" :alertContent="alertContent" :alertSubject="alertSubject"
    :isDismiss="false" :timeToEnable="1" />
  <GeneralModal :modalId="'extendAppModal'" :modalTitle="'تمديد فترة إقامة المركبة'"
    :modalFormLabel="'تمديد إلى تاريخ :'" :documents="extendDocs" :inputFields="extendFields"
    :modalSubmitFnc="'extendRequest'" />
  <!-- <GeneralModal :modalId="'dropAppModal'" :modalTitle="'طلب إسقاط المركبة من النظام'"
                :modalFormLabel="'هذا الطلب استثنائي وفي حالات الطوارئ فقط ، وبتقديمك هذا الطلب فإنك تتحمل كافة المسؤوليات القانونية المترتبة عليه ، يجب إرفاق المستندات المطلوبة وإحضار النسخة الأصلية إلى المركز الجمركي للتأكد من صحتها والموافقة على طلبك'"
                :documents="dropDocs"
                :inputFields="dropFields" :modalSubmitFnc="'dropRequest'" /> -->


</template>

<script>
import GeneralModal from "@/components/Modal.vue";
import ApplicantForm from "@/components/Applicant/ApplicantForm";
import AlertModal from "@/components/AlertModal.vue";
import { Modal } from 'bootstrap';
import router from "@/router";
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      alertSubject: "",
      alertContent: "",
      redirectTo: "1",
      transTypeChanges: 0,
      ID: this.$route.params.id,
      CHECKNO: this.$route.params.checkNo,
      STATUS: this.$route.params.status,
      isFormDisabled: true,
      oldApplicant: {},
      formFields: {
        appType: { 
          id: "appType",
          label: "",
          type: 'radio',
          tab: 'owner',
          value: 0,
          required: "required",
          options: [
            {id:1 , name: "خروج من ليبيا (تصدير مؤقت)"},
            {id:2 , name: "دخول ليبيا (استيراد مؤقت)"}
          ],
          optionName: "name",
          disabled: true,
         }, 
        applicantName: { id: 'ownerName', label: 'اسم السائق', type: 'text', tab: 'owner', value: "", required: "required" },
        phoneNo: { id: 'phoneNo', label: 'رقم الهاتف', type: 'text', tab: 'owner', value: "", required: "required" },
        nationNo: { id: 'nationNo', label: 'الرقم الوطني', type: 'text', tab: 'owner', value: (this.$route.params?.nationNo) ?? "", visibility: 1, }, // 0 => for non-Libyan, 1 => Libyan 
        departId: {
          id: "departId",
          label: "المعبر",
          type: 'select',
          tab: 'owner',
          value: this.$route.params?.departId,
          required: "required",
          options: [],
          optionName: "name",
          placeholder: "اختر المعبر",
        },
        nationalityId: {
          id: "nationalityId",
          label: "الجنسية",
          type: 'select',
          tab: 'owner',
          value: '',
          required: "required",
          options: [],
          optionName: "name",
          placeholder: "اختر الجنسية",
          disabled: true,
        },
        cityId: {
          id: "city",
          label: "المدينة",
          type: 'select',
          tab: 'owner',
          value: "", required: "required",
          options: [],
          optionName: "name",
          placeholder: "اختر المدينة",
          visibility: 1, // 0 => for non-Libyan, 1 => Libyan 
        },
        cityText: { id: 'cityText', label: 'المدينة', type: 'text', tab: 'owner', value: "", placeholder: "المدينة أو المحافظة", required: "required", visibility: 0, }, // 0 => for non-Libyan, 1 => Libyan  
        address: { id: 'address', label: 'العنوان', type: 'text', tab: 'owner', value: "", placeholder: "العنوان (الحي أو الشارع)", required: "required" },
        passNo: { id: 'passportNumber', label: 'رقم الجواز', type: 'text', tab: 'owner', value: (this.$route.params?.passNo) ?? "", required: "required" },
        passAutoNo: { id: 'passAutoNo', label: 'الرقم الآلي', type: 'text', tab: 'owner', value: "", visibility: 1, required: "required" }, // 0 => for non-Libyan, 1 => Libyan 
        licenseNo: { id: 'licenseNo', label: 'رقم رخصة القيادة', type: 'text', tab: 'owner', value: "", required: "required" },
        transTypeId: {
          id: "transType",
          label: "نوع المركبة",
          type: 'select',
          tab: 'vehicle',
          value: (this.$route.params?.nationalityId != 1) ? 3 : "",
          required: "required",
          options: [],
          optionName: "name",
          placeholder: "اختر النوع",
        },
        madeId: {
          id: "made",
          label: "المُصنّع",
          type: 'select',
          tab: 'vehicle',
          value: "", required: "required",
          options: [],
          optionName: "name",
          placeholder: "اختر المُصنّع",
        },
        transModel: { id: 'transModel', label: 'طراز المركبة', type: 'text', tab: 'vehicle', value: "", required: "required" },
        transColor: { id: 'transColor', label: 'لون السيارة', type: 'text', tab: 'vehicle', value: "", required: "required" },
        transDate: { id: 'transDate', label: 'تاريخ الصنع', type: 'text', tab: 'vehicle', value: "", required: "required" },
        engineNo: { id: 'engineNo', label: 'رقم المحرك', type: 'text', tab: 'vehicle', value: "", required: false },
        chassisNo: { id: 'chassisNo', label: 'رقم الهيكل', type: 'text', tab: 'vehicle', value: "", required: "required" },
        plateNo: { id: 'plateNo', label: 'رقم اللوحة', type: 'text', tab: 'vehicle', value: "", required: "required" },
      },
      documents: [
        { typeName: "جواز السفر", file: null, preview: null, typeId: 1 },
        { typeName: "بطاقة شخصية", file: null, preview: null, typeId: 2 },
        { typeName: "رخصة القيادة", file: null, preview: null, typeId: 3 },
      ],

      extendFields: {
        // appId: { id: 'appId', label: '', type: 'hidden', value: this.ID, required: "required", disabled: true },
        newExpDate: { id: 'newExpDate', label: 'تمديد إلى تاريخ', type: 'date', placeholder: 'تاريخ التمديد بما يتوافق مع المستندات المرفقة', value: Date.toString(), required: "required" },
        note: { id: 'note', label: 'ملاحظات: ', type: 'text', placeholder: 'ملاحظات: (اختياري)', value: null },
      },
      dropFields: {
        // appId: { id: 'appId', label: '', type: 'hidden', value: this.ID, required: "required", disabled: true },
        reasone: { id: 'reasone', label: 'السبب القانوني', type: 'text', placeholder: 'سبب طلب الإسقاط بما يتوافق مع المستندات المرفقة', value: null, required: "required" },
        note: { id: 'note', label: 'ملاحظات: ', type: 'text', placeholder: 'ملاحظات: (اختياري)', value: null },
      },
      extendDocs: [],
      dropDocs: [],
    };
  },
  computed: {
    ...mapGetters(['getDeparts', 'getTransTypes', 'getTransMades', 'getCities', 'getDocTypes', 'getNationalities']),
    compTransTypeId: function () {
      // return this.formFields[11].value;
      return this.formFields.transTypeId.value;
    }
  },
  async created() {
    await this.fetchOptions();
    await this.fetchApplicantData();
  },
  components: {
    ApplicantForm,
    AlertModal,
    GeneralModal
  },
  watch: {
    compTransTypeId: async function (v) {
      if (this.transTypeChanges == 0) {
        this.transTypeChanges++
        return
      }
      await this.changeDocsByTrans(v);

    }
  },
  methods: {
    /** */
    ...mapActions([
      'fetchDeparts',
      'fetchTransTypes',
      'fetchTransMades',
      'fetchDocTypes',
      'fetchCities',
      'fetchNationalities',
    ]),
    /********************************/
    /** */
    async fetchOptions() {
      if (this.getDeparts.length == 0) {
        await this.fetchDeparts(); // Fetch and store in Vuex
      }
      if (this.getTransTypes.length == 0) {
        await this.fetchTransTypes();
      }
      if (this.getTransMades.length == 0) {
        await this.fetchTransMades();
      }
      if (this.getDocTypes.length == 0) {
        await this.fetchDocTypes();
      }
      if (this.getCities.length == 0) {
        await this.fetchCities();
      }
      if (this.getNationalities.length == 0) {
        await this.fetchNationalities();
      }
      this.formFields.departId.options = this.getDeparts
      this.formFields.cityId.options = this.getCities
      this.formFields.transTypeId.options = this.getTransTypes
      this.formFields.madeId.options = this.getTransMades
      this.formFields.nationalityId.options = this.getNationalities
      this.documents = this.getDocTypes;
      //
      if (this.STATUS == 2) {
        try {
          const extResponse = await this.$axios.get("api/docs/getextenddocs");

          if (extResponse?.data.isSuccess) {
            this.extendDocs = extResponse?.data.docTypes;
          } else {
            this.$tempAlert(extResponse.data.msg);
          }
        } catch (error) {
          console.error("Error fetching transTypes:", error);
        }
      }
    },
    /******************************/
    /** */
    async changeDocsByTrans(id) {
      try {
        const response = await this.$axios.post("api/docs/getrequiredbytransid", { transId: id });
        if (response?.data.isSuccess) {
          this.documents = response?.data.docTypes;
          this.documents.forEach((doc) => {
            doc['file'] = null;
            doc['preview'] = null;
          });
        } else {
          this.alertSubject = "فشل العملية";
          this.alertContent = response.data.msg;
        }
      } catch (error) {
        if (error.response?.data) {
          this.$tempAlert(error.response.data.msg, 'warning');
        }
        console.error("Submission error:", error);
      }
    },
    /******************************/
    /** */
    async fetchApplicantData() {
      try {
        const response = await this.$axios.post("api/applicant/getapplicantbyid/", { id: this.ID, checkNo: this.CHECKNO });
        const data = response.data.applicant;
        if (data) {
          this.oldApplicant = data;
          Object.keys(this.formFields).forEach(key => {
            this.formFields[key].value = data[key]
          });
          await this.changeDocsByTrans(this.formFields.transTypeId.value)
          console.log(data)
          this.documents.forEach((doc, index) => {
            doc.preview = data.docs[index].docPath
          });
          switch (data.status) {
            case 0:
              this.statusText = "تم الرفض"
              this.statusClass = "text-danger"
              break;
            case 1:
              this.statusText = "انتظار (قيد الإجراء)"
              this.statusClass = "text-success"
              break;
            case 2:
              this.statusText = "تم القبول (لم يدفع الإيصال المالي)"
              this.statusClass = "text-success"
              break;
            case 3:
              this.statusText = "أنهى إجراءات الخروج (تم دفع الإيصال المالي)"
              this.statusClass = "text-success"
              break;
            case 4:
              this.statusText = "أتم العودة"
              this.statusClass = "text-success"
              break;
            default:
              this.statusText = ""
              this.statusClass = ""

          }
        }

        console.log("data", data)
      } catch (error) {
        if (error.response?.data) {
          this.$tempAlert(error.response.data.msg, 'warning');
        }
        console.error('Error fetching applicant data:', error);
      }
    },
    /******************************/

    async submitForm() {
      const formData = new FormData();
      formData.append("applicantId", this.ID)
      formData.append("checkNo", this.CHECKNO)
      Object.keys(this.formFields).forEach((key) => {
        if (this.formFields[key].value == null) {
          this.formFields[key].value = "";
        }
        formData.append(key, (typeof (this.formFields[key].value) == 'string') ? this.formFields[key].value.trim() : this.formFields[key].value);
      });

      this.documents.forEach(doc => {
        if (doc.file) {
          formData.append('docImages', doc.file);
          formData.append('docTypes', doc.id);
        }
      });
      // const formDataObj = {};
      //   formData.forEach((value, key) => (formDataObj[key] = value));
      //   console.log("formData", formDataObj)
      try {
        const response = await this.$axios.post("api/applicant/update", formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if (response?.data.isSuccess) {
          const applicant = response.data.applicant
          this.alertSubject = "تمت التعديل بنجاح";
          this.alertContent = "رقم التسجيل : " + applicant.id + "<br/> رقم التحقق : " + applicant.checkNo + "<br/> <span class=''> قم بحفظ الأرقام لاستحدامها لحقاً </span>";
        } else {
          this.alertSubject = "فشل العملية";
          this.alertContent = response?.data.msg;
          this.redirectTo = '0';
        }
        // Trigger the modal display
        const alertModalInstance = new Modal(this.$refs.alertModal.$el);
        alertModalInstance.show();
        this.$refs.alertModal.isHidden = 0; // Start the timer
      } catch (error) {
        if (error.response?.data) {
          this.$tempAlert(error.response.data.msg, 'warning');
          var emsg = {
            msg: "",
            interval: 4000
          };
          error.response.data.errors.forEach((e) => {
            emsg.msg += e + "<br/>";
            emsg.interval += 2000;
          })
          setTimeout(() => {
            this.$tempAlert(emsg.msg, 'warning', emsg.interval);
          }, 1000)
        }
        console.error("Submission error:", error);
      }
    },
    /** */
    async extendRequest() {
      const formData = new FormData();
      formData.append("appId", this.ID)
      Object.keys(this.extendFields).forEach((key) => {
        // if(this.oldApplicant[key] !== this.extendFields[key].value){ // إيقاف مؤقت بسبب مشاكل في backend
        //   formData.append(key, this.extendFields[key].value);
        // }
        if (this.extendFields[key].value !== null) {
          formData.append(key, this.extendFields[key].value);
        }
      });

      this.extendDocs.forEach(doc => {
        if (doc.file) {
          formData.append('docImages', doc.file);
          formData.append('docTypes', doc.id);
        }
      });
      // const formDataObj = {};
      //   formData.forEach((value, key) => (formDataObj[key] = value));
      //   console.log("formData", formDataObj)
      try {
        const response = await this.$axios.post("api/applicant/extendrequest", formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if (response?.data.isSuccess) {
          this.alertSubject = "تم إرسال طلب التمديد بنجاح";
          this.alertContent = "رقم التسجيل : " + this.ID + "<br/> رقم التحقق : " + this.CHECKNO + "<br/> <span class=''> قم باستخدامها للمراجعة لاحقاً </span>";
        } else {
          this.alertSubject = "فشل العملية";
          this.alertContent = response?.data.msg;
        }
        // Trigger the modal display
        const alertModalInstance = new Modal(this.$refs.alertModal.$el);
        alertModalInstance.show();
        this.$refs.alertModal.isHidden = 0; // Start the timer
      } catch (error) {
        if (error.response?.data) {
          this.$tempAlert(error.response.data.msg, 'warning');
        }
        console.error("Submission error:", error);
      }
    },
    /** */
    // async dropRequest() {
    //   const formData = new FormData();
    //   formData.append("appId", this.ID)
    //   Object.keys(this.dropFields).forEach((key) => {
    //     if(this.dropFields[key].value !== null){
    //       formData.append(key, this.dropFields[key].value);
    //     }
    //   });

    //   this.dropDocs.forEach(doc => {
    //       if (doc.file) {
    //         formData.append('docImages', doc.file);
    //         formData.append('docTypes', doc.id);
    //       }
    //     });
    //   try {
    //     const response = await this.$axios.post("api/applicant/droprequest", formData, {
    //       headers: {
    //         'Content-Type': 'multipart/form-data',
    //       },
    //     });
    //     if (response?.data.isSuccess) {
    //       this.alertSubject = "تم إرسال طلب التمديد بنجاح";
    //       this.alertContent = "رقم التسجيل : " + this.ID + "<br/> رقم التحقق : " + this.CHECKNO + "<br/> <span class=''> قم باستخدامها للمراجعة لاحقاً </span>";
    //     } else {
    //       this.alertSubject = "فشل العملية";
    //       this.alertContent = response?.data.msg;
    //     }
    //     // Trigger the modal display
    //       const alertModalInstance = new Modal(this.$refs.alertModal.$el);
    //       alertModalInstance.show();
    //       this.$refs.alertModal.isHidden = 0; // Start the timer
    //     } catch (error) {
    //       if(error.response?.data){
    //         this.$tempAlert(error.response.data.msg,'warning');
    //       }
    //       console.error("Submission error:", error);
    //     }
    // },
  },
};
</script>

<style>
.form-container {
  background: #fff;
  padding-left: 11px;
  padding-right: 11px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  /* width: 60vw; */
  margin: auto;
}

.thumbnail {
  max-width: 70vw;
  height: 37vh;
  object-fit: cover;
  margin-top: 10px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
</style>
